import * as StandardEvents from 'https://cdn.shopify.com/storefront/standard-events.js';

      window.StandardEvents = StandardEvents;

      customElements.define('collection-component', StandardEvents.createViewEventElement());
      customElements.define(
        'product-component',
        StandardEvents.createViewEventElement(HTMLElement, { defaultTrigger: 'intersect' }),
      );

      document.addEventListener('DOMContentLoaded', () => {
        const template = document.querySelector('main[data-template]')?.dataset.template || '';
        document.dispatchEvent(
          new StandardEvents.PageViewEvent({
            page: { template, title: document.title, url: window.location.href },
          })
        );
      }, { once: true });